export const generateRandomColor = () => {
    const hue = Math.floor(Math.random() * 360);
    const saturation = Math.floor(Math.random() * 20) + 80;
    const lightness = Math.floor(Math.random() * 15) + 50;

    const color = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    return color;
}

export const calculateLuminance = (hexColor: string) => {
    const rgb = parseInt(hexColor.slice(1), 16);
    const r = (rgb >> 16) & 0xff;
    const g = (rgb >> 8) & 0xff;
    const b = (rgb >> 0) & 0xff;

    const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
    return luminance;
}

export const generateColor = () => {
    const color = generateRandomColor();
    const lum = calculateLuminance(color);
    const textColor = lum > 128 ? '#000000' : '#FFFFFF';

    return { color, textColor }
}